import { Skeleton } from "@/components/ui/skeleton";

export function AppLoadingSkeleton() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Nav skeleton */}
      <div className="h-12 border-b border-border/10 flex items-center px-6 gap-3">
        <Skeleton className="h-7 w-7 rounded-lg" />
        <Skeleton className="h-4 w-20" />
        <div className="flex-1" />
        <Skeleton className="h-8 w-16 rounded-full" />
        <Skeleton className="h-8 w-24 rounded-full" />
      </div>
      {/* Hero skeleton */}
      <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6">
        <Skeleton className="h-6 w-64 rounded-full" />
        <Skeleton className="h-16 w-96 max-w-full" />
        <Skeleton className="h-5 w-80 max-w-full" />
        <div className="flex gap-3 mt-4">
          <Skeleton className="h-12 w-48 rounded-full" />
          <Skeleton className="h-12 w-36 rounded-full" />
        </div>
      </div>
    </div>
  );
}
